import { useCallback } from "react";
import { useLiveDashboardStats } from "../../../global/hooks/useLiveDashboardStats";
import { getScheduleDashboard } from "../api/dashboardApi";
import { SCHEDULE_DATA_CHANGED_EVENT } from "./scheduleDataEvents";

export function useScheduleDashboardStats({
  enabled = true,
  reloadToken = 0,
  listScope = "self",
} = {}) {
  const fetcher = useCallback(() => getScheduleDashboard({ scope: listScope }), [listScope]);
  const selectData = useCallback((response) => response?.data ?? null, []);

  return useLiveDashboardStats({
    fetcher,
    enabled,
    selectData,
    refreshDeps: [reloadToken],
    dataChangedEventName: SCHEDULE_DATA_CHANGED_EVENT,
  });
}
